module.exports = __webpack_public_path__ + "img/PersonalDetails.08aa4486.svg";